import { useEffect, useState } from 'react';
import * as amplitude from '@amplitude/analytics-browser';
import { Analytics } from 'crono-fe-common/hooks/crono-extension/gateway';

// [IMPORTANT] Should be used only in the context, app should use exported hook from analytics context
export function useAmplitudeAnalytics(apiKey: string): Analytics | null {
  const [analytics, setAnalytics] = useState<Analytics | null>(null);

  useEffect(() => {
    if (typeof window === 'undefined' || !apiKey) return;

    const loadAnalytics = async () => {
      try {
        if (!amplitude.getDeviceId()) {
          amplitude.init(apiKey, {
            autocapture: false,
            fetchRemoteConfig: true,
            minIdLength: 1,
          });
        }

        const amplitudeWrapper: Analytics = {
          identify: async (userId, traits) => {
            const identifyObj = new amplitude.Identify();
            if (traits) {
              Object.entries(traits).forEach(([key, value]) => {
                identifyObj.set(key, value as string | number | boolean);
              });
            }
            amplitude.setUserId(userId);
            await amplitude.identify(identifyObj);
          },
          group: (groupId, traits) => {
            amplitude.setGroup('company', groupId, traits);
          },
          track: async (eventName, properties) => {
            amplitude.track(eventName, properties);
            return Promise.resolve();
          },
          user: () => ({
            id: () => amplitude.getUserId(),
          }),
        };

        setAnalytics(amplitudeWrapper);
      } catch (error) {
        console.error('Failed to initialize Amplitude:', error);
        setAnalytics(null);
      }
    };

    loadAnalytics();
  }, [apiKey]);

  return analytics;
}
